import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroDealers } from './filtro-dealer';
import { RelatorioSpnvFiltroService } from './relatorio-spnv-filtro.service';
import { RelatorioSpnvService } from './relatorio-spnv.service';

@Component({
  selector: 'app-relatorio-spnv',
  templateUrl: './relatorio-spnv.component.html',
  styleUrls: ['./relatorio-spnv.component.scss'],
})
export class RelatorioSpnvComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  cols: any[];
  colsChassis: any[];
  _selectedColumns: any[];
  dealersDados: any[] = [];
  chassisDados: any[] = [];
  dealerSelecionado: any;
  loading = false;
  loadingChassis = false;
  displayFiltrosDealers = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  maxDate: Date = new Date();
  filtrosDealers: FiltroDealers;
  cargaTela = true;
  userDealerIds = '';

  @ViewChild('dt') dt: Table;
  @ViewChild('dtChassis') dtChassis: Table;

  get colsSemDetalhe(): any[] {
    return this.cols.filter(c => c.field !== 'detalhe');
  }

  get dadosParaCalculo(): any[] {
    if (this.dt && this.dt.filteredValue) {
      return this.dt.filteredValue;
    }
    return this.dealersDados ?? [];
  }

  get isDealerVisible(): boolean {
    return this._selectedColumns?.some(c => c.field === 'dealer');
  }

  get totalVendasAcessorios(): number {
    return this.dadosParaCalculo.reduce((acc, cur) => acc + (Number(cur.vendasAcessorios) || 0), 0);
  }

  get totalNf0km(): number {
    return this.dadosParaCalculo.reduce((acc, cur) => acc + (Number(cur.nf0km) || 0), 0);
  }

  get totalRetailVista(): number {
    return this.dadosParaCalculo.reduce((acc, cur) => acc + (Number(cur.retailVista) || 0), 0);
  }

  get totalSpnvBaseNf(): number {
    const totalVendas = this.totalVendasAcessorios;
    const totalNf = this.totalNf0km;
    return totalNf > 0 ? totalVendas / totalNf : 0;
  }

  get totalSpnvBaseVista(): number {
    const totalVendas = this.totalVendasAcessorios;
    const totalRetail = this.totalRetailVista;
    return totalRetail > 0 ? totalVendas / totalRetail : 0;
  }

  constructor(
    private service: RelatorioSpnvService,
    public translate: TranslateService,
    private servico: RelatorioSpnvFiltroService,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder
  ) {
    this.filtros = {};
    this.nomeModulo = 'relatorio-spnv';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('YYYY-MM-DD')],
      data_final: [moment(this.dataFinal).format('YYYY-MM-DD')],
      dealer: [''],
    });
  }

  ngOnInit() {
    this.changeLanguageValue();

    this.cols = [
      { field: 'detalhe', header: '', width: '40px' },
      { field: 'codDealer', header: 'businessIntelligence.relatorioSpnv.codDealer', headerBr: 'Cód. Dealer', headerGb: 'Dealer Code' },
      { field: 'dealer', header: 'businessIntelligence.relatorioSpnv.dealer', headerBr: 'Dealer', headerGb: 'Dealer' },
      { field: 'vendasAcessorios', header: 'businessIntelligence.relatorioSpnv.vendasAcessorios', headerBr: 'Vendas de Acessórios', headerGb: 'Accessories Sales', type: 'currency' },
      { field: 'nf0km', header: 'businessIntelligence.relatorioSpnv.nf0km', headerBr: 'NF 0km', headerGb: 'NF 0km' },
      { field: 'retailVista', header: 'businessIntelligence.relatorioSpnv.retailVista', headerBr: 'Retail Vista', headerGb: 'Retail Vista' },
      { field: 'spnvBaseNf', header: 'businessIntelligence.relatorioSpnv.spnvBaseNf', headerBr: 'SPNV Base NF', headerGb: 'SPNV Base NF', type: 'currency' },
      { field: 'spnvBaseVista', header: 'businessIntelligence.relatorioSpnv.spnvBaseVista', headerBr: 'SPNV Base Vista', headerGb: 'SPNV Base Vista', type: 'currency' },
    ];

    this.colsChassis = [
      { field: 'chassi', header: 'businessIntelligence.relatorioSpnv.chassi', headerBr: 'Chassi', headerGb: 'Chassis' },
      { field: 'chassiBanco', header: 'businessIntelligence.relatorioSpnv.chassiBanco', headerBr: 'Chassi NF', headerGb: 'NF Chassis' },
      { field: 'chassiRetail', header: 'businessIntelligence.relatorioSpnv.chassiRetail', headerBr: 'Chassi Retail', headerGb: 'Retail Chassis' },
      { field: 'notaFiscal', header: 'businessIntelligence.relatorioSpnv.notaFiscal', headerBr: 'Nota Fiscal', headerGb: 'Invoice' },
      { field: 'dataNotaFiscal', header: 'businessIntelligence.relatorioSpnv.dataNotaFiscal', headerBr: 'Data NF', headerGb: 'Invoice Date' },
      { field: 'tipoDivergencia', header: 'businessIntelligence.relatorioSpnv.tipoDivergencia', headerBr: 'Divergência', headerGb: 'Divergence' },
    ];

    this._selectedColumns = this.cols.filter(c => c.field !== 'detalhe');

    this.filtrosDealers.carregar().then(() => {
      this.userDealerIds = this.filtrosDealers.idsUsuario();
      this.getAll();
    });
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col) && col.field !== 'detalhe');
  }

  get f() {
    return this.form.controls;
  }

  private getAll() {
    this.loading = true;
    this.chassisDados = [];
    this.dealerSelecionado = null;

    this.service
      .getResumo(
        this.f.data_inicial.value,
        this.f.data_final.value,
        this.userDealerIds,
        this.f.dealer.value || undefined
      )
      .subscribe(
        (response) => {
          this.dealersDados = response.dealers ?? [];
          this.loading = false;
          this.cargaTela = false;
        },
        () => {
          this.dealersDados = [];
          this.loading = false;
          this.cargaTela = false;
        }
      );
  }

  public detalharDealer(dealer: any) {
    this.dealerSelecionado = dealer;
    this.loadingChassis = true;
    this.chassisDados = [];

    this.service
      .getChassis(
        this.f.data_inicial.value,
        this.f.data_final.value,
        String(dealer.idDealer),
        this.userDealerIds
      )
      .subscribe(
        (response) => {
          this.chassisDados = (response.chassis ?? []).map(c => ({
            ...c,
            tipoDivergencia: this.tipoDivergencia(c),
          }));
          this.loadingChassis = false;
        },
        () => {
          this.chassisDados = [];
          this.loadingChassis = false;
        }
      );
  }

  private tipoDivergencia(row: any): string {
    if (row.chassiBanco && !row.chassiRetail) {
      return this.translate.instant('businessIntelligence.relatorioSpnv.divergencia.soNf');
    }
    if (!row.chassiBanco && row.chassiRetail) {
      return this.translate.instant('businessIntelligence.relatorioSpnv.divergencia.soRetail');
    }
    if (row.chassiBanco && row.chassiRetail) {
      return this.translate.instant('businessIntelligence.relatorioSpnv.divergencia.ambos');
    }
    return '';
  }

  public filtroAPI() {
    this.f.data_inicial.setValue(moment(this.dataInicial).format('YYYY-MM-DD'));
    this.f.data_final.setValue(moment(this.dataFinal).format('YYYY-MM-DD'));
    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const selecionados = this.filtrosDealers.selecionados();
    if (selecionados.length > 0) {
      this.f.dealer.setValue(selecionados.map(d => d.id).join(','));
    } else {
      this.f.dealer.setValue('');
    }
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    this.filtrosSelecionados();
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    this.filtrosSelecionados();
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();
    const firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);
    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value: string) {
    return value;
  }

  private translateHeader(item: string): string {
    const col = this.cols.find(c => c.header === item) || this.colsChassis.find(c => c.header === item);
    if (!col) {
      return item;
    }
    return this.translate.currentLang === 'br' ? col.headerBr : col.headerGb;
  }

  public exportExcel() {
    if (!this.dealersDados?.length) {
      return;
    }

    this.exportExcelService.nomeModulo = this.nomeModulo;
    const exportDados = this.dadosParaCalculo.map(r => {
      const linha: Record<string, unknown> = {};
      this._selectedColumns.forEach(c => {
        linha[this.translateHeader(c.header)] = r[c.field];
      });
      return linha;
    });

    const linhaTotal: Record<string, unknown> = {};
    const labelTotal = this.translate.currentLang === 'br' ? 'TOTAL NACIONAL' : 'NATIONAL TOTAL';
    this._selectedColumns.forEach(c => {
      const header = this.translateHeader(c.header);
      if (c.field === 'dealer') {
        linhaTotal[header] = labelTotal;
      } else if (c.field === 'codDealer') {
        linhaTotal[header] = this.isDealerVisible ? '' : labelTotal;
      } else if (c.field === 'vendasAcessorios') {
        linhaTotal[header] = this.totalVendasAcessorios;
      } else if (c.field === 'nf0km') {
        linhaTotal[header] = this.totalNf0km;
      } else if (c.field === 'retailVista') {
        linhaTotal[header] = this.totalRetailVista;
      } else if (c.field === 'spnvBaseNf') {
        linhaTotal[header] = this.totalSpnvBaseNf;
      } else if (c.field === 'spnvBaseVista') {
        linhaTotal[header] = this.totalSpnvBaseVista;
      } else {
        linhaTotal[header] = '';
      }
    });
    exportDados.push(linhaTotal);

    this.exportExcelService.ExportTOExcelJSON(exportDados);
  }

  public exportExcelChassis() {
    if (!this.chassisDados?.length || !this.dealerSelecionado) {
      return;
    }

    const codDealerCol = this.cols.find(c => c.field === 'codDealer');
    const dealerCol = this.cols.find(c => c.field === 'dealer');
    const codDealer = String(this.dealerSelecionado.codDealer ?? '');
    const nomeDealer = String(this.dealerSelecionado.dealer ?? '');

    this.exportExcelService.nomeModulo = this.nomeArquivoExportChassis(codDealer);

    this.exportExcelService.ExportTOExcelJSON(
      this.chassisDados.map(r => {
        const linha: Record<string, unknown> = {};
        if (codDealerCol) {
          linha[this.translateHeader(codDealerCol.header)] = codDealer || r.codDealer;
        }
        if (dealerCol) {
          linha[this.translateHeader(dealerCol.header)] = nomeDealer || r.dealer;
        }
        this.colsChassis.forEach(c => {
          linha[this.translateHeader(c.header)] = r[c.field];
        });
        return linha;
      })
    );
  }

  private nomeArquivoExportChassis(codDealer: string): string {
    const cod = codDealer.replace(/[^\w.-]/g, '_') || 'dealer';
    return `spnv_${cod}_${this.formatarDataArquivo()}`;
  }

  private formatarDataArquivo(): string {
    const hoje = new Date(Date.now());
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${hoje.getFullYear()}-${pad(hoje.getMonth() + 1)}-${pad(hoje.getDate())}`;
  }

  private changeLanguageValue() {
    this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (this.chassisDados?.length) {
        this.chassisDados = this.chassisDados.map(c => ({
          ...c,
          tipoDivergencia: this.tipoDivergencia(c),
        }));
      }
      if (this.dealersDados?.length) {
        this.getAll();
      }
    });
  }
}
